/**
 * cn() — Utility für die geportete Shell (components/ui-shell/*, layout/*).
 * 1:1 aus rmnc-personal übernommen (docs/SHELL_PORTIERUNG.md Punkt 1).
 * Die bestehenden Seiten nutzen weiterhin @/components/ui (ui.tsx) und
 * dessen eigene Klassenkonstanten — diese Datei ist neu und kollidiert
 * mit nichts Bestehendem.
 */
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
